import { UserContext } from "@/context/User/UserContext";
import { getTowns } from "@/services/Town.service";
import { Town } from "@/types/town.types";
import { useQuery } from "@tanstack/react-query";
import { ColumnDef } from "@tanstack/react-table";
import { useContext } from "react";
import { NavLink } from "react-router-dom";
import CreateTown from "../dialog/CreateTown";
import ColumnHeader from "../table/ColumnHeader";
import LawFirmTable from "../table/LawFirmTable";
import { Button } from "../ui/button";
import { Skeleton } from "../ui/skeleton";

const Towns = () => {
	const user = useContext(UserContext);

	const towns = useQuery({
		queryKey: ["towns"],
		queryFn: () => getTowns(user?.accessToken!),
		enabled: !!user?.accessToken,
		staleTime: 3000,
	});
	return (
		<div>
			<div className="flex justify-between items-center mb-4">
				<div>
					<h1 className="text-3xl font-bold">Towns</h1>
				</div>
				<CreateTown user={user} />
			</div>
			<div className="bg-white pb-4 border rounded-md shadow-sm">
				{towns.isLoading ? (
					<div className="grid gap-4 pt-4">
						{Array.from({ length: 10 }).map((_, num) => (
							<Skeleton key={num} className="h-12 w-full" />
						))}
					</div>
				) : towns.data ? (
					<LawFirmTable data={towns.data} columns={Columns} />
				) : (
					<p>No data</p>
				)}
			</div>
		</div>
	);
};

export default Towns;

const Columns: ColumnDef<Town>[] = [
	{
		accessorKey: "townid",
		header: ({ column }) => <ColumnHeader column={column} title="Town Id" />,
		cell: ({ row }) => (
			<div className="flex items-center">
				<NavLink to={`/town/${row.original.townid}`}>
					<Button variant="link" className="px-2 py-1 font-light">
						{row.getValue("townid")}
					</Button>
				</NavLink>
			</div>
		),
	},
	{
		accessorKey: "townname",
		header: ({ column }) => <ColumnHeader column={column} title="Name" />,
	},
	{
		accessorKey: "actions",
		cell: ({ row }) => (
			<div className="flex items-center">
				<NavLink to={`/town/${row.original.townid}`}>
					<Button variant="link" className="px-2 py-1 font-light">
						View
					</Button>
				</NavLink>
			</div>
		),
	},
];
